import { getRouterNavigator } from '@/routing'

export function handleNewClientVersionAvailable() {
  const navigate = getRouterNavigator()
  navigate('/new-client-version-available')
}
